<template>
  <div id="container-chart"></div>
</template>

<script>
import Highcharts from "highcharts";
import Exporting from 'highcharts/modules/exporting'
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: "CardUseSoilChart",
  props: {
    values: {
      required: true,
    },
  },
  data() {
    return {
      groupPR:[
        { text:'Floresta', color:'#497000', style: 'circle'},
        { text:'Silvicultura', color:'#A5F900', style: 'circle'},
        { text:"Agua ou espelho d'agua", color:'#273FB6', style: 'circle'},
        { text:'Pastagem', color:'#FEFD00', style: 'circle'},
        { text:'Agricultura Anual', color:'#EB5757', style: 'circle'},
        { text:'Area Alagada ou Pantanosa', color:'#43704C', style: 'circle'},
        { text:'Agricultura Perene', color:'#CE9E00', style: 'circle'},
        { text:'Mangue', color:'#C7FA72', style: 'circle'},
        { text:'Mancha Urbanizada' , color:'#8C2202', style: 'circle'},
      ],
      groupSia:[
        { text:'Floresta', color:'#497000', style: 'circle'},
        { text:'Silvicultura', color:'#A5F900', style: 'circle'},
        { text:"Água ou Espelho d'água", color:'#273FB6', style: 'circle'},
        { text:'Pastagem', color:'#FEFD00', style: 'circle'},
        { text:'Agricultura Anual (Soja, milho e trigo)', color:'#EB5757', style: 'circle'},
        { text:'Área Alagada e Área Pantanosa', color:'#43704C', style: 'circle'},
        { text:'Agricultura Perene e Semi-perene', color:'#CE9E00', style: 'circle'},
        { text:'Mangue', color:'#C7FA72', style: 'circle'},
        { text:'Mancha Urbanizada' , color:'#8C2202', style: 'circle'},
      ],
    }
  },
  mounted() {
    this.dataSource()
  },
  watch: {
    values(){
      if(this.values){
        this.dataSource();
      }
    }
  },
  methods: {
    dataSource() {
      let copy = [{
        name: 'Uso do Solo',
        colorByPoint: true,
        size: '75%',
        dataLabels: {
          formatter: function () {
            return this.y > 0 ? this.point.name : null;
          },
          color: '#FFF',
          distance: -30
        },
        data: []
      }];
      if (this.values && this.values.sia) {
        for (const item in this.values.tipos) {
          if(this.values.tipos[item]){
            copy[0].data.push({
              name: this.mapNameSia(item),
              y: this.values.tipos[item],
              color: this.mapColorSia(item),
            });
          }
        }
      } else {
        for (const item in this.values) {
          if(this.values[item]){
            copy[0].data.push({
              name: this.mapNamePR(item),
              y: this.values[item],
              color: this.mapColorPR(item),
            });
          }
        }
      }
      this.chartPreprocessing(copy);
    },
    mapNameSia(name) {
      if (name === 'Floresta') {
        return 'Floresta'
      } else if (name === 'Silvicultura') {
        return 'Silvicultura'
      } else if (name === "Água ou Espelho d'água") {
        return 'Água'
      } else if (name === 'Pastagem') {
        return 'Pastagem'
      } else if (name === 'Agricultura Anual (Soja, milho e trigo)') {
        return 'Agricultura'
      } else if (name === 'Área Alagada e Área Pantanosa') {
        return 'Campo Alagado'
      } else if (name === 'Agricultura Perene e Semi-perene') {
        return 'Agricultura Semi-perene'
      } else if (name === 'Mangue') {
        return 'Mangue'
      } else if (name === 'Mancha Urbanizada') {
        return 'Área Urbanizada'
      }
    },
    mapColorSia(name) {
      const finded = this.groupSia.find((item) => item.text === name);
      return finded.color;
    },
    mapNamePR(name) {
      if (name === 'Floresta') {
        return 'Floresta'
      } else if (name === 'Silvicultura') {
        return 'Silvicultura'
      } else if (name === "Agua ou espelho d'agua") {
        return 'Água'
      } else if (name === 'Pastagem') {
        return 'Pastagem'
      } else if (name === 'Agricultura Anual') {
        return 'Agricultura'
      } else if (name === 'Area Alagada ou Pantanosa') {
        return 'Campo Alagado'
      } else if (name === 'Agricultura Perene') {
        return 'Agricultura Semi-perene'
      } else if (name === 'Mangue') {
        return 'Mangue'
      } else if (name === 'Mancha Urbanizada') {
        return 'Área Urbanizada'
      }
    },
    mapColorPR(name) {
      const finded = this.groupPR.find((item) => item.text === name);
      return finded.color;
    },
    chartPreprocessing(copy) {
      let chart = document.getElementById('container-chart')
      if(copy.length > 0) {
        this.chartNew(copy)
        chart.style.visibility = 'visible'
        chart.style.display = 'block'
      } else {
        chart.style.visibility = 'hidden'
        chart.style.display = 'none'
      }
    },
    chartNew(series) {
      let total
      if(series) { total = series[0].data.map(p => p.y || 0).reduce((a, b) => a + b, 0) }
      Highcharts.chart('container-chart', {
        chart: {
          backgroundColor: 'transparent',
          type: 'pie',
          height: 250,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: { enabled: false },
        exporting: { enabled: false },
        tooltip: {
          headerFormat: '',
          formatter: function () {
            const point = this.point;
            let percentage = (point.y / total) * 100;
            const percentageNormalized = new Intl.NumberFormat("pt-BR").format((Math.round(percentage * 100)/100))  + '%';
            return point.name +': <b>'+percentageNormalized+'</b>';
          }
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>',
            }
          }
        },
        series: series,
      });
    },
  },
}
</script>

<style scoped>

</style>
